/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-identifier-name.reducer';

export const PatientIdentifierNameDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientIdentifierNameEntity = useAppSelector(state => state.patientIdentifierName.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientIdentifierNameDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientIdentifierName.detail.title">PatientIdentifierName</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.name">Name</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.name}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.country">Country</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.country}</dd>
          <dt>
            <span id="preferred">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.preferred">Preferred</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.preferred ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientIdentifierName.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierNameEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientIdentifierName.language">Language</Translate>
          </dt>
          <dd>{patientIdentifierNameEntity.language ? patientIdentifierNameEntity.language.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-identifier-name" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-identifier-name/${patientIdentifierNameEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientIdentifierNameDetail;
